﻿(() => {
  const root = document.querySelector(
    '.product-single--cro-teglie[data-product-handle="tegliefriggitrice"]',
  );

  if (!root) {
    return;
  }

  document.body.classList.add('pdp-cro-teglie-active');

  let isSyncingVariant = false;
  let isUpdatingSummary = false;
  let syncTimers = [];
  let productData = null;
  let originalEasySellButton = null;
  let easySellObserver = null;

  const sticky = root.querySelector('[data-cro-sticky]');
  const purchasePanel = root.querySelector('[data-cro-purchase-panel]');
  const codTriggers = Array.from(
    document.querySelectorAll('[data-cro-cod-trigger]'),
  );
  const stickyPrice = sticky?.querySelector('[data-cro-sticky-price]');
  const stickyVariant = sticky?.querySelector('[data-cro-sticky-variant]');
  const variantSelect = root.querySelector('select[id^="MainProductSelect-"]');
  const productJsonEl =
    document.querySelector('[id^="ProductJson-"].mainProductJson') ||
    document.querySelector('[id^="ProductJson-"]');

  if (productJsonEl) {
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch {
      productData = null;
    }
  }

  const hideEasySellSticky = () => {
    document
      .querySelectorAll(
        '#es-sticky, .es-sticky-btn.es-sticky-top, .es-sticky-product.es-sticky-top',
      )
      .forEach((node) => {
        if (node.dataset.croHidden === '1') {
          return;
        }

        node.dataset.croHidden = '1';
        node.setAttribute('aria-hidden', 'true');
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
        node.style.setProperty('opacity', '0', 'important');
      });
  };

  hideEasySellSticky();

  const easySellStickyObserver = new MutationObserver((mutations) => {
    const stickyAdded = mutations.some(
      (mutation) =>
        mutation.type === 'childList' &&
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.id === 'es-sticky' ||
              node.matches?.(
                '#es-sticky, .es-sticky-btn.es-sticky-top, .es-sticky-product.es-sticky-top',
              ) ||
              node.querySelector?.(
                '#es-sticky, .es-sticky-btn.es-sticky-top, .es-sticky-product.es-sticky-top',
              )),
        ),
    );

    if (stickyAdded) {
      hideEasySellSticky();
    }
  });

  easySellStickyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(() => easySellStickyObserver.disconnect(), 30000);

  const reviewsCount = document.querySelector(
    '.reviews-section-wrapper .reviews-count',
  );
  const reviewsCountNumber = reviewsCount?.querySelector('strong');
  if (reviewsCount && reviewsCountNumber) {
    reviewsCount.innerHTML = `Basato su <strong>${reviewsCountNumber.textContent}</strong> recensioni`;
  }

  const formatMoney = (cents) => {
    const value = Number(cents) / 100;
    const [wholePart, fractionalPart = '00'] = value.toFixed(2).split('.');
    const amount = `${wholePart}.${fractionalPart}`;
    const amountWithCommaSeparator = `${wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${fractionalPart}`;
    const amountNoDecimals = String(Math.round(value));
    const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      '.',
    );
    const fallback = `â‚¬${amountWithCommaSeparator}`;

    const format = window.theme?.strings?.moneyFormat;
    if (!format) {
      return fallback;
    }

    const formatted = format
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/gi,
        amountNoDecimalsWithCommaSeparator,
      )
      .replace(
        /\{\{\s*amount_no_decimals_with_apostrophe_separator\s*\}\}/gi,
        amountNoDecimals,
      )
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/gi,
        amountWithCommaSeparator,
      )
      .replace(
        /\{\{\s*amount_with_apostrophe_separator\s*\}\}/gi,
        `${wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${fractionalPart}`,
      )
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/gi, amount);

    if (/\{\{/.test(formatted)) {
      return fallback;
    }

    return formatted;
  };

  const getSelectedOptions = () =>
    Array.from(root.querySelectorAll('.js-single-option-selector'))
      .map((input) => {
        if (input.type === 'radio' && !input.checked) {
          return null;
        }

        return {
          index: input.dataset.index,
          value: input.value,
        };
      })
      .filter(Boolean);

  const findVariantFromSelection = () => {
    const selectedOptions = getSelectedOptions();

    if (selectedOptions.length && productData?.variants?.length) {
      const matchedVariant = productData.variants.find((variant) =>
        selectedOptions.every((option) => variant[option.index] === option.value),
      );

      if (matchedVariant) {
        return matchedVariant;
      }
    }

    if (variantSelect?.value && productData?.variants?.length) {
      return (
        productData.variants.find(
          (variant) => String(variant.id) === String(variantSelect.value),
        ) || null
      );
    }

    return null;
  };

  const getVariantLabel = (variant) => {
    const source =
      variant?.option1 || variant?.title || variant?.public_title || '';
    return String(source).split(' A ')[0].trim();
  };

  const getSummaryElements = () => {
    const offerRoot = root.querySelector('[data-cro-selected-offer]');

    return {
      offerRoot,
      selectedLabel:
        offerRoot?.querySelector('[data-cro-selected-label]') || null,
      selectedPrice:
        offerRoot?.querySelector('[data-cro-selected-price]') || null,
      variantLabelValue: root.querySelector('.variant-label-option-value'),
    };
  };

  const updateSelectedSummary = (variant) => {
    if (!variant || isUpdatingSummary) {
      return;
    }

    isUpdatingSummary = true;

    try {
      const { offerRoot, selectedLabel, selectedPrice, variantLabelValue } =
        getSummaryElements();
      const label = getVariantLabel(variant);
      const priceText = formatMoney(variant.price);

      if (selectedLabel && selectedLabel.textContent.trim() !== label) {
        selectedLabel.textContent = label;
      }

      if (selectedPrice && selectedPrice.textContent.trim() !== priceText) {
        selectedPrice.textContent = priceText;
      }

      if (variantLabelValue && variantLabelValue.textContent.trim() !== label) {
        variantLabelValue.textContent = label;
      }

      if (stickyVariant && stickyVariant.textContent.trim() !== label) {
        stickyVariant.textContent = label;
      }

      if (stickyPrice && stickyPrice.textContent.trim() !== priceText) {
        stickyPrice.textContent = priceText;
      }

      if ((!selectedLabel || !selectedPrice) && offerRoot) {
        offerRoot.innerHTML = `
          <span>Pacchetto selezionato</span>
          <strong>
            <span data-cro-selected-label>${label}</span>
            Â·
            <span data-cro-selected-price>${priceText}</span>
          </strong>
        `;
      }
    } finally {
      isUpdatingSummary = false;
    }
  };

  const syncCartVariantInputs = (variantId) => {
    root
      .querySelectorAll('select[name="id"], input[name="id"]')
      .forEach((input) => {
        if (input.value !== variantId) {
          input.value = variantId;
        }
      });
  };

  const syncVariantSelection = () => {
    if (isSyncingVariant) {
      return findVariantFromSelection();
    }

    const variant = findVariantFromSelection();
    if (!variant || !variantSelect) {
      return null;
    }

    isSyncingVariant = true;

    try {
      const variantId = String(variant.id);
      syncCartVariantInputs(variantId);

      if (variantSelect.value !== variantId) {
        variantSelect.value = variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

        if (window.jQuery) {
          window.jQuery(variantSelect).trigger('change');
          window.jQuery(root).trigger({ type: 'variantChange', variant });
        }
      }

      updateSelectedSummary(variant);
      return variant;
    } finally {
      isSyncingVariant = false;
    }
  };

  const scheduleVariantSync = () => {
    syncTimers.forEach((timer) => window.clearTimeout(timer));
    syncTimers = [];

    syncVariantSelection();
    syncTimers.push(window.setTimeout(() => syncVariantSelection(), 120));
  };

  const setStickyVisible = (visible) => {
    if (!sticky || !window.matchMedia('(max-width: 749px)').matches) {
      return;
    }

    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', String(!visible));
    document.body.classList.toggle('pdp-cro-sticky-visible', visible);
  };

  const closeEasySellModal = () => {
    const container = document.querySelector('#es-form-container');
    if (!container || container.offsetParent === null) {
      return;
    }

    const closeButton = container.querySelector(
      'button[aria-label*="close" i], button[aria-label*="chiudi" i], .close, [class*="close-button"], [class*="Close"]',
    );
    closeButton?.click();
  };

  const setCodTriggersWaiting = (waiting) => {
    codTriggers.forEach((trigger) => {
      trigger.classList.toggle('is-cro-waiting', waiting);
      trigger.disabled = false;
      trigger.removeAttribute('aria-disabled');

      if (waiting) {
        trigger.setAttribute('aria-busy', 'true');
      } else {
        trigger.removeAttribute('aria-busy');
      }
    });
  };

  const syncEasySellOverlay = () => {
    const container = document.querySelector('#es-form-container');
    if (!container) {
      return;
    }

    const style = window.getComputedStyle(container);
    const rect = container.getBoundingClientRect();
    const isOpen =
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity) > 0.05 &&
      rect.width > 0 &&
      rect.height > 0;

    container.classList.toggle('es-is-open', isOpen);
  };

  const setEasySellReady = (button) => {
    if (!button) {
      return false;
    }

    originalEasySellButton = button;
    root.classList.add('pdp-cro--enhanced');
    setCodTriggersWaiting(false);
    easySellObserver?.disconnect();
    syncEasySellOverlay();
    return true;
  };

  const findEasySellButton = () =>
    document.querySelector(
      '.product-single--cro-teglie #es-popup-button, #es-popup-button',
    );

  syncEasySellOverlay();

  const GHOST_BLOCKER_SELECTORS = [
    '.toasts',
    '.overlay-backdrop.overlay-toasts',
  ].join(',');

  const isHiddenOverlay = (node) => {
    const style = window.getComputedStyle(node);
    const rect = node.getBoundingClientRect();

    return (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity) < 0.05 ||
      rect.width < 2 ||
      rect.height < 2
    );
  };

  const fixGhostTapBlockers = () => {
    document.querySelectorAll(GHOST_BLOCKER_SELECTORS).forEach((node) => {
      const hidden = isHiddenOverlay(node);
      node.style.setProperty(
        'pointer-events',
        hidden ? 'none' : 'auto',
        'important',
      );
      node.style.setProperty(
        'touch-action',
        hidden ? 'none' : 'auto',
        'important',
      );
    });
  };

  const bindResponsiveTap = (elements, onActivate) => {
    elements.forEach((element) => {
      if (element.dataset.croTapBound === '1') {
        return;
      }

      element.dataset.croTapBound = '1';

      let touchStartY = 0;
      let touchMoved = false;

      element.addEventListener(
        'touchstart',
        (event) => {
          touchMoved = false;
          touchStartY = event.changedTouches?.[0]?.clientY ?? 0;
        },
        { passive: true },
      );

      element.addEventListener(
        'touchmove',
        (event) => {
          const currentY = event.changedTouches?.[0]?.clientY ?? touchStartY;
          if (Math.abs(currentY - touchStartY) > 8) {
            touchMoved = true;
          }
        },
        { passive: true },
      );

      element.addEventListener(
        'touchend',
        (event) => {
          if (touchMoved) {
            return;
          }

          event.preventDefault();
          onActivate(event, element);
        },
        { passive: false },
      );

      element.addEventListener('click', (event) => {
        if (event.defaultPrevented) {
          return;
        }

        onActivate(event, element);
      });
    });
  };

  fixGhostTapBlockers();

  const ghostBlockerObserver = new MutationObserver(() => {
    fixGhostTapBlockers();
    syncEasySellOverlay();
  });

  ghostBlockerObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    childList: true,
    subtree: true,
  });

  const ghostBlockerInterval = window.setInterval(fixGhostTapBlockers, 1500);
  window.setTimeout(() => {
    ghostBlockerObserver.disconnect();
    window.clearInterval(ghostBlockerInterval);
  }, 45000);

  const easySellOverlayObserver = new MutationObserver(() => {
    syncEasySellOverlay();
  });

  const esFormContainer = document.querySelector('#es-form-container');
  if (esFormContainer) {
    easySellOverlayObserver.observe(esFormContainer, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
      childList: true,
      subtree: true,
    });
  }

  window.setTimeout(() => easySellOverlayObserver.disconnect(), 60000);

  setCodTriggersWaiting(true);

  if (!setEasySellReady(findEasySellButton())) {
    easySellObserver = new MutationObserver(() => {
      setEasySellReady(findEasySellButton());
    });
    easySellObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    window.setTimeout(() => easySellObserver?.disconnect(), 12000);
  }

  const openEasySellCheckout = () => {
    closeEasySellModal();
    const variant = syncVariantSelection();

    if (variantSelect && variant) {
      syncCartVariantInputs(String(variant.id));

      if (variantSelect.value !== String(variant.id)) {
        variantSelect.value = String(variant.id);
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    originalEasySellButton =
      originalEasySellButton || findEasySellButton();

    if (originalEasySellButton) {
      setStickyVisible(false);
      originalEasySellButton.click();
      syncEasySellOverlay();
      return;
    }

    root
      .querySelector('.product-single__add-to-cart')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  codTriggers.forEach((trigger) => {
    bindResponsiveTap([trigger], (event, triggerEl) => {
      if (triggerEl.classList.contains('is-cro-waiting')) {
        return;
      }

      event.preventDefault();

      if (triggerEl.closest('.pdp-cro__purchase-panel')) {
        root
          .querySelector('.pdp-cro__purchase-panel [data-cro-cod-trigger]')
          ?.classList.add('is-pulse-paused');
      }

      openEasySellCheckout();
    });
  });

  const initVariantCards = () => {
    const fieldset = root.querySelector('.single-option-radio');
    if (!fieldset || fieldset.dataset.croVariantBound === '1') {
      return;
    }

    fieldset.dataset.croVariantBound = '1';
    fieldset.setAttribute('role', 'radiogroup');

    const cards = Array.from(
      fieldset.querySelectorAll('label.pdp-cro__variant-card'),
    );

    cards.forEach((card) => {
      const inputId = card.getAttribute('for');
      if (inputId) {
        card.dataset.croVariantInput = inputId;
        card.removeAttribute('for');
      }

      card.setAttribute('role', 'radio');
    });

    const getCardInput = (card) => {
      const inputId = card.dataset.croVariantInput;
      return inputId ? document.getElementById(inputId) : null;
    };

    const updateVariantCardState = () => {
      cards.forEach((card) => {
        const input = getCardInput(card);
        const isChecked = Boolean(input?.checked);
        card.setAttribute('aria-checked', isChecked ? 'true' : 'false');
        card.setAttribute('tabindex', isChecked ? '0' : '-1');
      });
    };

    const selectVariantCard = (card) => {
      const input = getCardInput(card);
      if (!input || input.disabled) {
        return;
      }

      closeEasySellModal();

      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        if (window.jQuery) {
          window.jQuery(input).trigger('change');
        }
      }

      updateVariantCardState();
      scheduleVariantSync();
    };

    let lastActivateAt = 0;
    let lastActivateInputId = '';

    const shouldDedupeActivate = (inputId) => {
      const now = Date.now();
      if (inputId === lastActivateInputId && now - lastActivateAt < 450) {
        return true;
      }

      lastActivateInputId = inputId;
      lastActivateAt = now;
      return false;
    };

    const handleActivate = (event) => {
      const card = event.target.closest('.pdp-cro__variant-card');
      if (!card || !fieldset.contains(card)) {
        return;
      }

      if (
        event.type === 'pointerup' &&
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }

      const inputId = card.dataset.croVariantInput || '';
      if (shouldDedupeActivate(inputId)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      selectVariantCard(card);
    };

    fieldset.addEventListener('pointerup', handleActivate, true);
    fieldset.addEventListener(
      'touchend',
      handleActivate,
      { capture: true, passive: false },
    );
    fieldset.addEventListener('click', handleActivate, true);

    fieldset.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      const card = event.target.closest('.pdp-cro__variant-card');
      if (!card) {
        return;
      }

      event.preventDefault();
      selectVariantCard(card);
    });

    updateVariantCardState();
    fieldset._updateVariantCardState = updateVariantCardState;
  };

  initVariantCards();

  bindResponsiveTap(
    Array.from(document.querySelectorAll('[data-cro-scroll-to-purchase]')),
    (event) => {
      event.preventDefault();
      purchasePanel?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    },
  );

  root.addEventListener('change', (event) => {
    if (event.target.matches('.js-single-option-selector')) {
      closeEasySellModal();
      scheduleVariantSync();
      root.querySelector('.single-option-radio')?._updateVariantCardState?.();
    }
  });

  scheduleVariantSync();

  if (sticky && purchasePanel && 'IntersectionObserver' in window) {
    let purchasePanelHasBeenVisible = false;

    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          purchasePanelHasBeenVisible = true;
          setStickyVisible(false);
          return;
        }

        const hasScrolledPastPurchasePanel =
          purchasePanelHasBeenVisible && entry.boundingClientRect.top < 0;
        setStickyVisible(hasScrolledPastPurchasePanel);
      },
      {
        threshold: 0.08,
      },
    );

    stickyObserver.observe(purchasePanel);
  }

  window.addEventListener('resize', () => {
    if (!window.matchMedia('(max-width: 749px)').matches) {
      setStickyVisible(false);
    }
  });
})();
